import {
  XSD_DAY_TIME_DURATION_IRI,
  XSD_DECIMAL_IRI,
  XSD_DOUBLE_IRI,
  XSD_DURATION_IRI,
  XSD_FLOAT_IRI,
  XSD_INTEGER_IRI,
  XSD_STRING_IRI,
  XSD_YEAR_MONTH_DURATION_IRI,
} from 'bones/constants/iris';
import { DatatypeRange } from 'bones/utils/queryBuilder/constants';

const compareGroups: DatatypeRange[][] = [
  [XSD_DECIMAL_IRI, XSD_DOUBLE_IRI, XSD_FLOAT_IRI, XSD_INTEGER_IRI],
  [XSD_DURATION_IRI, XSD_DAY_TIME_DURATION_IRI],
  [XSD_DURATION_IRI, XSD_YEAR_MONTH_DURATION_IRI],
];

export const canCompareDatatypeRange = (
  maybeFrom: DatatypeRange,
  maybeTo: DatatypeRange
) => {
  // if null (a datatype we haven't defined), default to xsd:string
  const from = maybeFrom || XSD_STRING_IRI;
  const to = maybeTo || XSD_STRING_IRI;
  return (
    from === to ||
    Boolean(
      compareGroups.find((group) => group.includes(from) && group.includes(to))
    )
  );
};
